import React, { useState, useEffect } from "react";
import "./Template_3.css";
import apiService from "../../Common/Configurations/APIService";
import config from "../../Common/Configurations/APIConfig";
import DefaultData from "../../CompanyData/DefaultData";

const Template_3_TravelTypes = () => {
  const [travelTypes, setTravelTypes] = useState([]);
  const [isLoading, setIsLoading] = useState(false);

  const companyId = DefaultData.DEFAULTCOMPANYID;

  const travelTypeMeta = {
    Honeymoon: {
      icon: "fa-solid fa-heart",
      description: "Intimate retreats for couples",
    },
    Family: {
      icon: "fa-solid fa-users",
      description: "Multi-generational luxury escapes",
    },
    Pilgrims: {
      icon: "fa-solid fa-hands-praying",
      description: "Sacred journeys with premium amenities",
    },
    Corporate: {
      icon: "fa-solid fa-briefcase",
      description: "Executive travel solutions",
    },
    Group: {
      icon: "fa-solid fa-user-group",
      description: "Curated group expeditions",
    },
  };

  const formatTitle = (str) =>
    str ? str.charAt(0).toUpperCase() + str.slice(1).toLowerCase() : "";

  useEffect(() => {
    const GetTravelTypes = async () => {
      setIsLoading(true);
      try {
        const travelTypesResponse = await apiService.getAll(
          `${config.GETALLTRAVELTYPES}?companyId=${companyId}`
        );

        const mergedData = (travelTypesResponse || []).map((item) => {
          const formattedName = formatTitle(item.travelTypeName);

          const meta = travelTypeMeta[formattedName] || {};
          return {
            id: item.travelTypeId,
            title: formattedName,
            icon: meta.icon || "fa-solid fa-plane",
            description: meta.description || "Bespoke journeys",
          };
        });

        setTravelTypes(mergedData);
      } catch (error) {
        console.error("Failed to fetch travel types:", error);
      } finally {
        setIsLoading(false);
      }
    };

    GetTravelTypes();
  }, [companyId]);

  return (
    <section className="Template_3 section Template_3 travel-types-section">
      <div className="Template_3 container">
        <div className="Template_3 section-title">
          <h2>Travel Styles</h2>
          <p>Personalized approaches to luxury exploration</p>
        </div>

        {isLoading ? (
          <p>Preparing travel styles...</p>
        ) : (
          <div className="Template_3 travel-types-list">
            {travelTypes.map((type) => (
              <div key={type.id} className="Template_3 travel-type">
                <i className={type.icon}></i>
                <h3>{type.title}</h3>
                <p>{type.description}</p>
              </div>
            ))}
          </div>
        )}
      </div>
    </section>
  );
};

export default Template_3_TravelTypes;
